import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps, useHistory } from "react-router-dom";
import * as api from "../../api";
import {
  saveAssociatedAssests, saveCustomerphoneNumber, saveTenancySummaryList, saveCustomerTenacies, saveCustomerDetails, selectedTenacyType, workOrderRepairObject, getReferenceNumber, getHeatingHotWaterCase,
  getMaintResp,
  getRepairResp,
  getContractorName,
  getDeterminedContractorDetails,
  getContractorPayload,
  saveCurrentAssetEligibilityDetails,
  saveSubSessionAssetsEligibilityDetails,
} from "../../ducks/redux/actions/getAddress";
import { customersData, isActiveTenancy, userChosenPropertyAddress, userChosenPropertyId, getAssetList, defaultAssetId, premisesTypeList, userChosenAccountNumber, userChosentenancyGroup, userChosenAccountData, userChosenCustomerAccountData, userChosenBackValue, customerPreferenceData, userChosenAlertValue, userChosenIsRecall, loadDuplicateRepairPage, userChosenResumeRepair, userChosenDuplicateEntity, userChosenCurrentValue, backToCaseAsset, caseAssetAddress, userChosentenancyCount, userChosenReporterId, caseCreatedBy, userChosenAssociatedAssetsList, customerAdditionalAlertData, clearMediaFiles, userChosenUploadedMediaIdentifiers, assetDataStatus, selectedTenancyGroup, userChosenAssetValue, userChosenAssetHierarchy360, backToRepairAsset, repairAddressData, setRepairDiagnosticFinalData, woFailureCase } from "../../ducks/redux/actions/userChoices";
import CustomerResponseDetails from "../../models/Customer/CustomerResponseDetails";
import { PremisesType, PremisesTypeId } from "../../models/Customer/Premises";
import Tenancies from "../../models/Customer/Tenancies";
import TenancySummary from "../../models/Customer/TenancySummary";
import { AssocitaedAssetsType, RelatedPremisesType } from "../../models/Property/AdminUnits";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import AssetCard from "../AssetCard";
import CustomerCard from "../CustomerCard";
import RentCard from "../RentCard";
import WorkCard from "../WorkCard";
import AccountCard from "../AccountCard";
import { PropertySelect } from "./components";
import { BalanceType } from "../../models/Accounts/BalanceType";
import KeyContact from "../KeyContact";
import UCCTenancyDetails from "../UCCTenancyDetails";
import UCCRentDetails from "../UCCRentDetails";
import { PermissionsList } from "../../models/Permissions";
import { trackEvent } from "../../appInsights/TelemetryService";
import { AlertValue, BackValue, SearchType, CustomerOrProperty } from "../../models/shared/Enum";
import CautionAlert from "../CautionAlert"
import PropertyAlert from "../PropertyAlert";
import {
  userChosenUPRN,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenDuplicateQuestion,
  userChosenEmergencyQuestion,
  userChosenRepairLocationId,
  userChosenHighLevelDescription,
  userChosenRepairLocation,
  userChosenSupplementaryQuestions,
  userChosenSOR,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  userChosenIsReporter,
  assetDataResponse,
  assetsByIDData,
  checkForLandlord, isCatalystProperty, userChosenIsSurvey, userChosenTenancyTypeDescription
} from "../../ducks/redux/actions/userChoices";
import { updateDashboardForm, userTypedRepairReasons, assetByIdDataObject, priorityCode } from "../../ducks/redux/actions/dashboardReducer.actions";
import { AccountTypeList } from "../../models/Accounts/AccountType";
import { CASE_ASSET_CHECK, CASE_CUSTOMER_NAME, CASE_SELECTED_ANSWERS, CASE_TENANCY_ID, CLEAR_CASE_STATE, CONTACT_INFORMATION_VALUE, EDIT_BUTTON_CLICK } from "../../ducks/redux/actionTypes";
import CaseCard from "../Cases/CaseCard";
import Preference from "../../models/Customer/Preference";
import AdditionalNeedAlert from "../AdditionalNeedAlert";
import { addAPIError, removeAPIError,isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import { formatContent, getDeepLink, isNullOrUndefined, hasOverdueService} from '../../utils/formatting';
import openNewWindow from "../../assets/icons/Open-new-window-icon.png";
import { getserviceCardData } from "../ServiceCard/serviceCard";
import RedAlert from "../RedAlert";
import BackToTopComponent from "../BackToTop";
import useBackToTop from "../BackToTop/useBackToTop";
import { finishJourney, getPreviousPageName, storeAPIErrors } from "../../ducks/redux/actions/FinancialReferral";
import { checkPermissionAndSetState } from "../../utils/GetRoles/permission";
import { getAccountByIdServiceCharges, getAccountsByCustomerId, getAssociatedAssets, getAssetsById, getCustomer, getTenancies, getCustomerData } from "../APIErrorComponent/APIConstantName";
import { asset } from "../../models/Case/Case";

interface Customer360ViewProps extends RouteComponentProps<any> { }
const Customer360View: React.FC<Customer360ViewProps> = (props) => {
  const isCheckForLandlord = process.env.REACT_APP_ISCHECKFORLANDLORD;
  const [isLoading, setIsLoading] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false);
  const [errorCustomerFlag, setErrorCustomerFlag] = useState(false)
  const [isCustomerAccountAPIFailure, setIsCustomerAccountAPIFailure] = useState<boolean>(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  let errorData: any = [];
  const { backToTop, width } = useBackToTop();
  const history = useHistory();
  const customerId = useSelector(
    (state: any) => state?.userChoicesReducer?.custommerID
  );
  const isCaseCheck = useSelector(
    (state: any) => state?.userChoicesReducer?.isCaseAllowed
  );
  const isP360Maintainence = useSelector(
    (state: any) => state.userChoicesReducer?.isP360RepairsMaintainenceValue
  );
  const errors = useSelector((state: any) => state.financialReferralReducer?.APIerrors);

  const assetDataDetails = useSelector((state: any) => state?.addresses?.assetData);

  const [dropDown, setDropDown] = useState("none");
  const [defaultAssociatedAsset, setDefaultAssociatedAsset] = useState("");
  const arrayArea: Array<{ key: string; value: string }> = [];
  const [customerData, setCustomerData] = useState<CustomerResponseDetails>();
  const [associatedAssetList, setAssociatedAssetsList] = useState(arrayArea);
  const [inAssociatedAssetList, setInAssociatedAssetsList] = useState(arrayArea);
  const tenancies: Tenancies[] = [];
  const [tenanciesData, setTenanciesData] = useState(tenancies);
  const [Area, setArea] = useState(false);
  const [isCustomerCard, setIsCustomerCard] = useState(false);
  const [isWorkCard, setIsWorkCard] = useState(false);
  const [isAssetCard, setIsAssetCard] = useState(false);
  let [isAccountCard, setIsAccountCard] = useState(false);
  const [showRent, setShowRent] = useState(false);
  const [showAccount, setShowAccount] = useState(true);
  const [isRentCard, setIsRentCard] = useState(false);
  const [isKeyContact, setIsKeyContact] = useState(false);
  const [isRepair, setIsRepair] = useState(false);
  const [isCautionBanner, setIsCaution] = useState(false);
  const [activeTenancy, setActiveTenancy] = useState(false);
  const [preferenceCheck, setPreferenceCheck] = useState(false);
  const [isPropertyBanner, setIsProperty] = useState(false);
  const [showVantage, setShowVantage] = useState(false);
  const [propertyBannerCheck, setPropertyBannerCheck] = useState(false);
  const [isUCCCard, setIsUCCCard] = useState(false);
  const [userAsset, setUserAsset] = useState<any>();
  const getPermissionsData = useSelector((state: any) => state?.userChoicesReducer?.userProfilePermissions);
  const createCaseStandard = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.create_case_standard) !== -1;
  const customerDataVal = useSelector((state: any) => state?.userChoicesReducer?.customersData);
  const [isServiceRequestCard, setIsServiceRequestCard] = useState(true);
  const [isRentAccountCard, setIsRentAccountCard] = useState(true);
  const [isTenancyDetailsCard, setIsTenancyDetailsCard] = useState(true);
  const [isRentDetailsCard, setIsRentDetailsCard] = useState(true);
  const [landlordValues, setLandlordValues] = useState([""]);
  const [identifiedCatalystProperty, setIdentifiedCatalystProperty] = useState(false);
  const [catalystBannerMessageA, setCatalystBannerMessageA] = useState("");
  const [catalystBannerMessageB, setCatalystBannerMessageB] = useState("");
  const [isCaseCard, setIsCaseCard] = useState(false);
  const [additionalAlert, setAdditionalAlert] = useState(false);
  const [EICRserviceAlert, setEICRServiceAlert] = useState("");
  const [GASserviceAlert, setGASServiceAlert] = useState("");
  const [EICRCardToggleValue, setEICRCardToggleValue] = useState("false");
  const [GASCardToggleValue, setGASCardToggleValue] = useState("false");
  const [tenancyStatus, setTenancyStatus] = useState(false);
  const [UCCReferenceData, setUCCReferenceData] = useState<any>([]);
  const [customerAccountDataValue, setcustomerAccountDataValue] = useState<any>();
  const [isAssetEligibleForRepair, setIsAssetEligibleForRepair] = useState(false);

  let subSessionAssetsEligibilityDetailsRedux = useSelector(
    (state: any) => state?.addresses?.subSessionAssetsEligibilityDetails
  );

  let assetRegionValue: string = "";
  let tenancyGroup: string = "";

  const premisesList: RelatedPremisesType[] = [];
  enum LandlordAppConfigValues {
    IsCheckForLandlord = "IsCheckForLandlordP360",
    LandlordValues = "LandlordValues",
    CatalystRepairDisabledAreas = "CatalystRepairDisabledAreasP360",
    CatalystRegistrationAreas = "CatalystRegistrationAreas",
    isCataLystCaseCard = "isCataLystCaseCard"
  };
  const colleagueCompanyName = localStorage.getItem('user_companyName') || ""
  const hideCustomerKeyDetails = colleagueCompanyName?.toLowerCase() == "orbis"
  let associatedAssetsCount: number = 0;
  const finishJourney = useSelector((state: any) => state?.financialReferralReducer?.isJourneyFinish);
  const clear = () => {
    dispatch(userChosenIsSurvey(false));
    dispatch(userChosentenancyCount(0))
    dispatch(backToCaseAsset(false))
    dispatch(userChosenPropertyAddress(""));
    dispatch(getReferenceNumber(null))
    dispatch(userChosenRepairLocationId(0));
    dispatch(userChosenRepairLocation(""));
    dispatch(userTypedRepairReasons(""));
    dispatch(userChosenHighLevelDescription(""));
    dispatch(userChosenSupplementaryQuestions(""));
    dispatch(userChosenEmergencyQuestion(""));
    dispatch(userChosenPropertyId(""));
    dispatch(userChosenDuplicateQuestion(""));
    dispatch(userChosenDuplicateEntity(""));
    dispatch(userChosenAdditionalDescription(""));
    dispatch(userChosenVandalismQuestion("No"));
    dispatch(userChosenVandalismAdditionalInformation(""));
    dispatch(userChosenCovidQuestion(""));
    dispatch(userChosenVulnerabilityQuestion(""));
    dispatch(userChosenVulnerabilityAdditionalInformation(""));
    dispatch(userChosenContactDetails(""));
    dispatch(userChosenUPRN(""));
    dispatch(userChosenSOR(""));
    dispatch(getRepairResp(""));
    dispatch(getHeatingHotWaterCase(""));
    dispatch(getMaintResp(""));
    dispatch(getDeterminedContractorDetails(""));
    dispatch(getContractorName(""));
    dispatch(getContractorPayload(""));
    dispatch(userChosenSTATUS(""));
    dispatch(userChosenEligibilityErrorCode(""));
    dispatch(userChosenContactPhone(""));
    dispatch(userChosenContactName(""));
    dispatch(userChosenRelationDetails(""));
    dispatch(selectedTenacyType(""));
    dispatch(workOrderRepairObject(null));
    dispatch(userChosenIsReporter(false));
    dispatch({ type: CLEAR_CASE_STATE });
    dispatch({ type: CASE_SELECTED_ANSWERS });
    dispatch(saveCustomerphoneNumber(''));
    dispatch(caseAssetAddress(""))
    dispatch(userChosenRelationDetails(''))
    dispatch(userChosenReporterId(''))
    dispatch({ type: EDIT_BUTTON_CLICK, payload: false })
    dispatch(loadDuplicateRepairPage(false));
    dispatch(userChosenResumeRepair(false));
    dispatch(caseCreatedBy(""));
    dispatch({ type: CASE_CUSTOMER_NAME, payload: '' })
    dispatch({ type: CASE_ASSET_CHECK, payload: false })
    dispatch({ type: CONTACT_INFORMATION_VALUE })
    dispatch({ type: CASE_TENANCY_ID })
    dispatch(customerPreferenceData({}))
    dispatch(customerAdditionalAlertData({}))
    dispatch(clearMediaFiles([]));
    dispatch(userChosenUploadedMediaIdentifiers([]));
    dispatch(assetByIdDataObject(null));
    dispatch(selectedTenancyGroup(''));
    dispatch(userChosenAssetValue(null));
    dispatch(userChosenAssetHierarchy360(null));
    dispatch(saveAssociatedAssests(null));
    dispatch(userChosenBackValue(null));
    dispatch(userChosenCurrentValue(null));
    dispatch(priorityCode(""));
    dispatch(backToRepairAsset(false));
    dispatch(repairAddressData([]));
    dispatch(setRepairDiagnosticFinalData(null));
    dispatch(saveCurrentAssetEligibilityDetails([null]));
  }

  const EICRCardToggle = "isshowp360eicrcard";
  const GASCardToggle = "isshowp360gasboilercard";

  const sortTenanciesByLatestResidentialStatus = (tenancyResponse: Tenancies[], customerSearchApiData: any, customerResponse: CustomerResponseDetails): Tenancies[] => {
    let sortedTenancies: Tenancies[] = [];

    //Customer Search data is already sorted by latest residential status 
    customerSearchApiData[0].tenancyModels?.forEach((tenancy: any) => {
      const tenancyId = customerResponse.tenanciesSummaries?.filter((x) => x.tenancySummary.paymentReference === tenancy.paymentReference)[0]?.tenancySummary?.tenancyId;
      const tenancyData = tenancyResponse?.filter((x) => x.tenancyIdentifier === tenancyId)[0];
      if (tenancyData) {
        sortedTenancies.push(tenancyData);
      }
    });
    //push remaining tenancies from tenancyResponse which are not in sortedTenancies
    tenancyResponse?.forEach((tenancy: any) => {
      const isTenancyExists = sortedTenancies?.some((x) => x.tenancyIdentifier === tenancy.tenancyIdentifier);
      if (!isTenancyExists) {
        sortedTenancies.push(tenancy);
      }
    });
    //remove duplicates from sortedTenancies
    const uniqueTenancies = new Map(sortedTenancies.map((item) => [item.tenancyIdentifier, item]));
    sortedTenancies = Array.from(uniqueTenancies.values());
    return sortedTenancies;
  }
  const getIsShowP360AssetComplianceDataToggle = async () => {
    try {
      const EICRCardToggleResponse = await api.GetAppConfigToggleValue(EICRCardToggle);
      const GASCardToggleResponse = await api.GetAppConfigToggleValue(GASCardToggle);

      if (EICRCardToggleResponse) {
        setEICRCardToggleValue(EICRCardToggleResponse.value);
      }

      if (GASCardToggleResponse) {
        setGASCardToggleValue(GASCardToggleResponse.value);
      }
    } catch (error) {
      console.error("Error fetching toggle values:", error);
    }
  };

  const checkPremisesEligibility = async (
    premisesId: any,
    tenancyGroup: any,
    assetType: any,
    associatedAssetsData: any
  ) => {
    let assetEligibilityForRaiseRepair;
    const currentAssetCachedEligibilityOutcome = subSessionAssetsEligibilityDetailsRedux?.find((assetEligDetailEle: any) => assetEligDetailEle.assetId == premisesId);
    if (!isNullOrUndefined(currentAssetCachedEligibilityOutcome)) {
      assetEligibilityForRaiseRepair = currentAssetCachedEligibilityOutcome;
    }
    else {
      const responsePremisesEligibilityResp = await api.postPremisesEligibility(
        premisesId,
        tenancyGroup
      );
      const assetTypeId = Number.parseInt(PremisesTypeId[assetType]);
      const hasParentPresent = associatedAssetsData?.filter((x: any) => {
        const associatedTypeId = Number.parseInt(PremisesTypeId[x.assetType]);
        return associatedTypeId < assetTypeId;
      });
      const hasParent = hasParentPresent?.length > 0 ? true : false;
      if (responsePremisesEligibilityResp?.length > 0) {

        const responsePremisesEligibility = responsePremisesEligibilityResp[0];
        const matchBR12BR13 = (responsePremisesEligibility?.errorCode === "E4" && assetType !== "Property") || responsePremisesEligibility?.errorCode === "E24";
        assetEligibilityForRaiseRepair = {
          assetId: premisesId,
          assetEligibilityResponse: responsePremisesEligibility,

          // We want to stop scenario when asset matches BR 12 & BR13 and is capable of skipping Repair Asset page
          isEligibleToRaiseARepair: !responsePremisesEligibility?.isEligible && !hasParent && matchBR12BR13 ? false : true
        }

      }
      let assetEligibilityDetailsCache = subSessionAssetsEligibilityDetailsRedux ?? [];
      assetEligibilityDetailsCache.push(assetEligibilityForRaiseRepair);
      dispatch(saveSubSessionAssetsEligibilityDetails(assetEligibilityDetailsCache));
    }

    dispatch(saveCurrentAssetEligibilityDetails(assetEligibilityForRaiseRepair));
    setIsAssetEligibleForRepair(assetEligibilityForRaiseRepair.isEligibleToRaiseARepair);
  }
  const callingGetCustomerDataAPI = async (queryParams: any) => {
    try {
      const response = await api.getCustomerData(queryParams);
      errorData = removeAPIError(getCustomerData, errors);
      dispatch(storeAPIErrors(errorData));
      return response?.models;
    } catch (error) {
      console.error("Error fetching customer data:", error);
      errorData = addAPIError(getCustomerData, errors);
      dispatch(storeAPIErrors(errorData));
      return [];
    }
  };
  const showworksOrderSurveys = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.view_work_order_summary_card) !== -1;
  useEffect(() => {
    // Adding a toggle to display/hide service card and alerts
    getIsShowP360AssetComplianceDataToggle()
    window.scrollTo(0, 0);
    (async () => {
      try {
        const viewCustomer360View = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.view_customer_360_view) !== -1;
        if (!viewCustomer360View) {
          props.history.push("/LandingView");
        }
        dispatch(userChosenAssociatedAssetsList(null));
        dispatch(saveAssociatedAssests(null));
        trackEvent("Customer360View");
        clear();
        dispatch(userChosenIsRecall(false))
        dispatch(userChosenBackValue(BackValue.Customer360View));
        dispatch(userChosenCurrentValue(BackValue.Customer360View));
        dispatch(caseCreatedBy(SearchType.Customer));
        setIsLoading(true);

        checkPermissionAndSetState(getPermissionsData, PermissionsList.view_customer_profile_card, setIsCustomerCard);

        checkPermissionAndSetState(getPermissionsData, PermissionsList.view_work_order_summary_card, setIsWorkCard);


        isAccountCard = checkPermissionAndSetState(getPermissionsData, PermissionsList.view_asset_details_card, setIsAssetCard);
        checkPermissionAndSetState(getPermissionsData, PermissionsList.view_customer360_multi_account_summary_card, setIsAccountCard);

        checkPermissionAndSetState(getPermissionsData, PermissionsList.view_customer360_multi_account_summary_card, setIsRentCard);


        checkPermissionAndSetState(getPermissionsData, PermissionsList.view_key_contacts_card || PermissionsList.view_customer360_keydetails_card, setIsKeyContact);


        checkPermissionAndSetState(getPermissionsData, PermissionsList.create_repair_standard, setIsRepair);


        checkPermissionAndSetState(getPermissionsData, PermissionsList.view_customer360_caution_alerts_banner, setIsCaution);


        checkPermissionAndSetState(getPermissionsData, PermissionsList.view_asset360_property_alerts_banner, setIsProperty);


        checkPermissionAndSetState(getPermissionsData, PermissionsList.view_open_crm, setShowVantage);

        let customerResponse: any;
        try {
          customerResponse = await api.getCustomer(customerId);
          errorData = removeAPIError(getCustomer, errors);
          setErrorCustomerFlag(false);
          dispatch(storeAPIErrors(errorData));
        } catch (error) {
          console.error("Error fetching customer", error);
          errorData = addAPIError(getCustomer, errors);
          setErrorCustomerFlag(true);
          dispatch(storeAPIErrors(addAPIError(getCustomer, errorData)));
        }
        let tenancyResponse: any;
        try {
          tenancyResponse = await api.getTenancies(customerId);
          errorData = removeAPIError(getTenancies, errors);
          dispatch(storeAPIErrors(errorData));
        } catch (error) {
          console.error("Error fetching tenancies", error);
          errorData = addAPIError(getTenancies, errors);
          dispatch(storeAPIErrors(addAPIError(getTenancies, errorData)));
        }
        const uprnFromCustomerResponse = customerResponse?.tenanciesSummaries?.filter(
          (ts: any) =>
            ts.tenancySummary.statuses.find(
              (s: any) => s.type === "isTenancyActive"
            )?.value === true
        )[0]?.tenancySummary?.uprn;
        const queryParams = {
          searchText: "",
          skip: 0,
          customerType: "Active Customer",
          orderBy: "",
          tenancyType: "",
          uprn: uprnFromCustomerResponse ?? assetDataDetails?.uprn,
        };
        const customerSearchApiData = await callingGetCustomerDataAPI(queryParams)
        tenancyResponse = customerSearchApiData.length > 0 ? sortTenanciesByLatestResidentialStatus(tenancyResponse, customerSearchApiData, customerResponse) : tenancyResponse;
        if (customerResponse?.preferences?.length > 0) {
          let customerAdditionalAlertDataObj: Preference[] = [];
          let customerPreferenceAlertObj: Preference[] = [];
          customerAdditionalAlertDataObj = customerResponse?.preferences?.filter((additionalNeedAlert: any) => additionalNeedAlert.preference.type === 'additionalNeeds');
          customerPreferenceAlertObj = customerResponse?.preferences?.filter((additionalNeedAlert: any) => additionalNeedAlert.preference.type !== 'additionalNeeds');
          if (customerPreferenceAlertObj.length > 0) {
            setPreferenceCheck(true)
            dispatch(customerPreferenceData(customerPreferenceAlertObj))
          }
          if (customerAdditionalAlertDataObj.length > 0) {
            setAdditionalAlert(true);
            dispatch(customerAdditionalAlertData(customerAdditionalAlertDataObj))
          }
        }
        else {
          const queryParams = {
            searchText: "",
            skip: 0,
            customerType: "Active Customer",
            orderBy: "",
            tenancyType: "",
            uprn: assetDataDetails?.uprn,
          };
          const customerSearchApiData = await callingGetCustomerDataAPI(queryParams);

          let additionalNeedAlertDataObj = customerSearchApiData?.filter
            ((additionalNeedAlert) =>
              additionalNeedAlert?.preferences?.some((data: any) => data?.type == 'additionalNeeds'));

          if (additionalNeedAlertDataObj.length > 0) {
            dispatch(customerAdditionalAlertData(additionalNeedAlertDataObj))
          }
        }

        setTenanciesData(tenancyResponse)
        dispatch(
          saveCustomerphoneNumber(customerResponse?.addresses?.telecomsAddresses)
        );
        dispatch(saveCustomerDetails(customerResponse));
        dispatch(customersData(customerResponse));
        getActiveAssociatedAsset(customerResponse, tenancyResponse);
        setCustomerData(customerResponse);
      }
      catch (e) {
        setIsLoading(false)
        console.error(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPermissionsData]);

  const fetchAccountData = async (paymentReference: string) => {
    try {
      const accountBalance = await api.getAccount(paymentReference);
      dispatch(storeAPIErrors(removeAPIError(getAccountByIdServiceCharges, errors)))
      setErrorFlag(false);
      return accountBalance;
    } catch (e) {
      dispatch(storeAPIErrors(addAPIError(getAccountByIdServiceCharges, errors)));
      setErrorFlag(true);
      return null;
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const assetProperty = userAsset && userAsset?.filter((eachAsset: any) => eachAsset.assetType === 'Property');
        const tenancySum = userAsset && customerDataVal?.tenanciesSummaries && customerDataVal?.tenanciesSummaries?.filter((eachSummary: any) => eachSummary.tenancySummary.uprn === assetProperty[0].uprn && eachSummary.tenancySummary.statuses[0].value === true);
        const response = await api.getUCCReferenceData();
        if (UCCReferenceData.length == 0) {
          const response = await api.getUCCReferenceData();
          let arrayTenancyType = Object?.values(response[0].namespace.keyValues);
          setUCCReferenceData(arrayTenancyType);
        }
        const filteredArrayTenancyType = UCCReferenceData?.filter((el: any) => el.tenancyTypeID === tenancySum?.[0]?.tenancySummary?.tenancyType);
        const isDisplayUC = filteredArrayTenancyType && filteredArrayTenancyType[0]?.displayUC;
        const showUCCCard = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.view_customer360_customer_UCC_Card);
        dispatch(userChosenTenancyTypeDescription(formatContent(filteredArrayTenancyType?.[0]?.tenancyType)));
        setTenancyStatus(true);
        if (showUCCCard !== -1 && isDisplayUC) {
          setIsUCCCard(true);
        }
        else {
          setIsUCCCard(false);
        }
      } catch (error) { }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userAsset, customerDataVal]);

  useEffect(() => {
    setIsServiceRequestCard(
      Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.view_case_summary_card) !== -1
    );
    setIsRentAccountCard(
      Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.customer360_view_rent_account_card) !== -1
    );
    setIsTenancyDetailsCard(
      Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.customer360_view_tenency_details_card) !== -1
    );
    setIsRentDetailsCard(
      Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.customer360_view_rent_details_card) !== -1
    );
  }, [getPermissionsData]);

  const getGasBoilerData = async(assetId:string)=> {
    const complianceType = t("GASService")
    const EICR = t("EICRService")
    try {
      const [res, res1] = await Promise.allSettled([
        getserviceCardData(assetId, EICR, false),
        getserviceCardData(assetId, complianceType, false)
      ]);
      // Safely access .value only if status is 'fulfilled'
       const resValue = res.status === "fulfilled" ? res.value : undefined;
       const res1Value = res1.status === "fulfilled" ? res1.value : undefined;
  
        const serviceData = resValue?.filter((appliance: any) => appliance?.applianceType === 'EICREQUI');
        const gasServiceData = res1Value?.filter((appliance: any) => appliance?.applianceType === 'GASBOIL');
        if (hasOverdueService(serviceData?.[0]?.nextServiceDueDate)) {
          setEICRServiceAlert(`There is an Electrical service overdue for this property. Please contact ${serviceData?.[0]?.contractor?.name || "-"} on ${serviceData?.[0]?.contractor?.phoneNumber || "-"} to schedule a service visit.`);
        }
        if (hasOverdueService(gasServiceData?.[0]?.nextServiceDueDate)) {
          setGASServiceAlert(`There is a Gas boiler service overdue for this property. Please contact ${gasServiceData?.[0]?.contractor?.name || "-"} on ${gasServiceData?.[0]?.contractor?.phoneNumber || "-"} to schedule a service visit.`);
        }
      
    } catch (e: any) {
      console.log(e)
    }
  }

  const checkforLandlordValues = async (assetId: string, currentAssetRegion: string) => {
    const appCatalystRegistrationAreasValues = await api.GetAppConfigToggleValue(
      LandlordAppConfigValues.CatalystRegistrationAreas
    );
    const appCatalystRepairDisabledAreasValues = await api.GetAppConfigToggleValue(
      LandlordAppConfigValues.CatalystRepairDisabledAreas
    );

    const isCatalystRegistrationAreas = !isUndefinedNullOrEmpty(currentAssetRegion) && appCatalystRegistrationAreasValues.value.toLowerCase().includes(currentAssetRegion.toLowerCase())
    const isCatalystDisabledArea = !isUndefinedNullOrEmpty(currentAssetRegion) && appCatalystRepairDisabledAreasValues.value.toLowerCase().includes(currentAssetRegion.toLowerCase());
    let isEnabledCatalystProperty = isCatalystRegistrationAreas && !isCatalystDisabledArea

    if (isCheckForLandlord === "true") {
      const isCataLystCaseCardValue = await api.GetAppConfigToggleValue(
        LandlordAppConfigValues.isCataLystCaseCard
      );
      const appConfigIsCheckForLandlord = await api.GetAppConfigToggleValue(
        LandlordAppConfigValues.IsCheckForLandlord
      );

      if (appConfigIsCheckForLandlord?.value === "true") {
        const appConfigLandlordValues = await api.GetAppConfigToggleValue(
          LandlordAppConfigValues.LandlordValues
        );

        let appconfigLandlordValues = appConfigLandlordValues?.value;
        let landlordsList = appconfigLandlordValues.split(",");
        setLandlordValues(landlordsList);

        const associatesdata = await api.GetPropertyAssociates(assetId);

        let currentLandlord = associatesdata?.associates?.landLord?.organisation?.name;
        let previousLandLord = associatesdata?.associates?.previousLandLord?.organisation?.name;

        const landlordValuesExist = currentLandlord?.length > 0 || previousLandLord?.length > 0
        if (landlordValuesExist) {
          const isCatalystLandlord =
            (currentLandlord?.length > 0 && appconfigLandlordValues.includes(currentLandlord)) ||
            (previousLandLord?.length > 0 && appconfigLandlordValues.includes(previousLandLord));

          const identifiedCatalystProperty = isCatalystRegistrationAreas || isCatalystLandlord
          isEnabledCatalystProperty = isCatalystLandlord && isEnabledCatalystProperty
          dispatch(isCatalystProperty(identifiedCatalystProperty))
          setIsWorkCard(!isCatalystRegistrationAreas || isEnabledCatalystProperty);
          dispatch(checkForLandlord(identifiedCatalystProperty));
          setIdentifiedCatalystProperty(isCatalystRegistrationAreas);
          setIsCaseCard(isCataLystCaseCardValue.value !== "true");
        }
        else {
          dispatch(isCatalystProperty(isCatalystRegistrationAreas))
        }
      }
      else {
        dispatch(isCatalystProperty(isCatalystRegistrationAreas))

      }
    } else {
      dispatch(isCatalystProperty(isCatalystRegistrationAreas))
    }

    switch (assetRegionValue) {
      case 'HUB1-REP':
        setCatalystBannerMessageA(t("CP126EnabledHub1a"));
        setCatalystBannerMessageB(t("CP126EnabledHubb"));
        break;
      case 'HUB2-REP':
        setCatalystBannerMessageA(t("CP126EnabledHub2a"));
        setCatalystBannerMessageB(t("CP126EnabledHubb"));
        break;
      case 'HUB3-REP':
        setCatalystBannerMessageA(t("CP126EnabledHub3a"));
        setCatalystBannerMessageB(t("CP126EnabledHubb"));
        break;
      case 'HUB4-REP':
        setCatalystBannerMessageA(t("CP126EnabledHub4a"));
        setCatalystBannerMessageB(t("CP126EnabledHubb"));
        break;
      default:
        // For Non Catalyst Properties, isIdentifiedCatalystProperty will be false, message wont be visible
        // For Catalyst properties where landlord is catalyst but fron a diff asset region
        setCatalystBannerMessageA(t("CP125a"));
        setCatalystBannerMessageB(t("CP125b"));
        break;
    }

    if (isCatalystDisabledArea) {
      setCatalystBannerMessageA(t("CP125a"));
      setCatalystBannerMessageB(t("CP125b"));
    }

  }
  const fetchAssetInfo = async (key: any) => {
    try {
      const associatedAssetsResponse = await api.getAssociatedAssets(key);
      dispatch(storeAPIErrors(removeAPIError(getAssociatedAssets, errors)));
      return associatedAssetsResponse;
    } catch (error) {
      dispatch(storeAPIErrors(addAPIError(getAssociatedAssets, errors)));
      console.error("Error fetching associated assets:", error);
      return null;
    }
  }
  const getAssociatedAsset = async (key: any) => {
    try {
      const assetsByID = await api.getAssetsByid(key);
      dispatch(storeAPIErrors(removeAPIError(getAssetsById, errors)));
      dispatch(assetByIdDataObject(assetsByID));
      dispatch(assetsByIDData(assetsByID));
      dispatch(assetDataStatus(assetsByID.assetStatus));
      assetRegionValue = assetsByID?.region;

      let associtaedAssets: any[] = [];
      const associatedAssetsResponse = await fetchAssetInfo(key);
      associtaedAssets.push(associatedAssetsResponse)
      dispatch(saveAssociatedAssests(associtaedAssets));
      dispatch(assetDataResponse(associatedAssetsResponse));
      setUserAsset(associatedAssetsResponse);
      associatedAssetsResponse?.forEach((element) => {
        const premisesEntry: RelatedPremisesType = new RelatedPremisesType();
        premisesEntry.premisesType = element.assetType as PremisesType;
        premisesEntry.premisesTypeId = element.id;
        premisesList.push(premisesEntry);
      });

      await checkPremisesEligibility(
        assetsByID?.id,
        tenancyGroup,
        assetsByID?.assetType,
        associatedAssetsResponse
      );

      dispatch(premisesTypeList(premisesList))

      checkforLandlordValues(key, assetRegionValue);
    }
    catch (e) {
      dispatch(storeAPIErrors(addAPIError(getAssetsById, errors)));
      setIsLoading(false)
      console.error(e);
    }
  }
  const optionsFromPremises = (associatedAssetList: any) =>
    associatedAssetList.map((e: any, key: any) => ({
      key: e.value,
      value: e.key,
    }))
  const getActiveAssociatedAsset = async (
    customerResponse: CustomerResponseDetails,
    tenancyResponse: Tenancies[]
  ) => {
    try {

      const activeTenanciesSummaries =
        customerResponse?.tenanciesSummaries.filter(
          (ts) =>
            ts.tenancySummary.statuses.find(
              (s) => s.type === "isTenancyActive"
            )?.value === true
        );
      if (activeTenanciesSummaries.length > 0) {
        dispatch({ type: CASE_TENANCY_ID, payload: activeTenanciesSummaries[0]?.tenancySummary?.tenancyId })
      }

      dispatch(saveCustomerTenacies(activeTenanciesSummaries));
      if (activeTenanciesSummaries.length > 0) {
        const tenancySummaryList: TenancySummary[] = [];
        if (tenancyResponse.length > 1) {
          tenancyResponse.map((ts: any) => {
            let tenancySummaryEntry: TenancySummary[] =
              activeTenanciesSummaries.filter(
                (x) => x.tenancySummary.tenancyId === ts.tenancyIdentifier
              );

            if (tenancySummaryEntry.length > 0) {
              tenancySummaryEntry[0]["tenancySummary"]["tenancyTypeGroup"] = ts.tenancyGroup;
              tenancySummaryList.push(tenancySummaryEntry[0]);
            }
          });
        } else {
          tenancySummaryList.push(activeTenanciesSummaries[0]);
        }
        dispatch(saveTenancySummaryList(tenancySummaryList));
        dispatch({ type: CASE_TENANCY_ID, payload: tenancySummaryList[0]?.tenancySummary?.tenancyId })

        const activeTenanciesPremises = tenancySummaryList
          .flatMap((ts: any) => {
            const tenancyId = ts?.tenancySummary?.tenancyId;
            const paymentReference = ts?.tenancySummary?.paymentReference;
            return ts?.tenancySummary?.premisesIds.map((premiseId: any) => ({
              tenancyId,
              premiseId,
              paymentReference
            })) || [];
          });

        const promises = activeTenanciesPremises.map(async (item: any) => {
          const data = await fetchAssetInfo(item.premiseId);
          return {
            tenancyId: item.tenancyId,
            premiseId: item.premiseId,
            paymentReference: item.paymentReference,
            data
          };
        });

        Promise.all(promises).then((results) => {
          const associatedAssetsList: AssocitaedAssetsType[] = [];
          results.forEach((item: any) => {
            const address = item.data?.find((addressItem: any) => addressItem.id === item.premiseId);
            const uniqueKey = `${item.premiseId}_${item.tenancyId}_${item.paymentReference}`;
            const associatedAssetsTypeEntry: AssocitaedAssetsType = new AssocitaedAssetsType();
            associatedAssetsTypeEntry.key = uniqueKey;
            associatedAssetsTypeEntry.value = address?.addresses?.postalAddresses?.[0]?.formattedAddress;
            associatedAssetsList.push(associatedAssetsTypeEntry);
          });
          const premiseId = associatedAssetsList[0]?.key.split("_")[0];
          setDefaultAssociatedAsset(associatedAssetsList[0]?.key);
          getGasBoilerData(premiseId);
          getAssociatedAsset(premiseId);
          callAlertApi(premiseId);
          setAssociatedAssetsList(associatedAssetsList);
          dispatch(userChosenAssociatedAssetsList(associatedAssetsList));
          associatedAssetsCount = associatedAssetsCount + associatedAssetsList.length;
          dispatch(isActiveTenancy(true));
          setActiveTenancy(true);
          dispatch(defaultAssetId(premiseId))
          dispatch(
            updateDashboardForm({
              assetId: premiseId
            })
          );
          dispatch(userChosenPropertyAddress(associatedAssetsList[0]?.value));
          let TenancySummaryEntry = activeTenanciesSummaries.find(
            (st) => st.tenancySummary.premisesIds[0] === premiseId
          );
          if (TenancySummaryEntry !== undefined && TenancySummaryEntry !== null) {
            let tenancyResponseEntry = tenancyResponse.find(x => x.tenancyIdentifier === TenancySummaryEntry?.tenancySummary?.tenancyId)
            if (tenancyResponseEntry !== undefined && tenancyResponseEntry !== null) {
              tenancyGroup =
                tenancyResponseEntry?.tenancyGroup;
              if (tenancyGroup !== undefined && tenancyGroup !== null) {
                dispatch(userChosentenancyGroup(tenancyGroup));
              }
            }
            let paymentReference =
              TenancySummaryEntry?.tenancySummary?.paymentReference;
            if (paymentReference !== undefined && paymentReference !== null && !hideCustomerKeyDetails) {
              (async () => {
                try {
                  const accountBalance = await fetchAccountData(paymentReference);
                  getCustomeAccountData(true, paymentReference)

                  dispatch(
                    userChosenAccountData(accountBalance)
                  );
                }
                catch (e) {
                  console.log(e);
                  getCustomeAccountData(false, null)
                  dispatch(
                    userChosenAccountData(null)
                  );
                  setIsLoading(false)
                }
              })();
              dispatch(userChosenAccountNumber(paymentReference));
            }
            else {
              setIsLoading(false)
            }
          }
          if (associatedAssetsCount > 1) {
            setArea(true);
          } else {
            setArea(false);
          }
        }).then(() => getActiveInAssociatedAsset(customerResponse, tenancyResponse))
      }
      else {
        getActiveInAssociatedAsset(customerResponse, tenancyResponse)
      }

    }
    catch (e) {
      setIsLoading(false)
      console.error(e);
    }
  }
  const getActiveInAssociatedAsset = async (
    customerResponse: CustomerResponseDetails,
    tenancyResponse: Tenancies[]
  ) => {
    try {
      const inActiveTenanciesSummaries =
        customerResponse?.tenanciesSummaries.filter(
          (ts) =>
            ts.tenancySummary.statuses.find(
              (s) => s.type === "isTenancyActive"
            )?.value === false
        );
      if (inActiveTenanciesSummaries.length > 0) {
        const tenancySummaryList: TenancySummary[] = [];
        if (tenancyResponse.length > 1) {
          tenancyResponse.map((ts: any) => {
            let tenancySummaryEntry: TenancySummary[] =
              inActiveTenanciesSummaries.filter(
                (x) => x.tenancySummary.tenancyId === ts.tenancyIdentifier
              );

            if (tenancySummaryEntry.length > 0) {
              tenancySummaryEntry[0]["tenancySummary"]["tenancyTypeGroup"] = ts.tenancyGroup;
              tenancySummaryList.push(tenancySummaryEntry[0]);
            }
          });
        } else {
          tenancySummaryList.push(inActiveTenanciesSummaries[0]);
        }
        dispatch(saveTenancySummaryList(tenancySummaryList));

        const activeTenanciesPremises = tenancySummaryList
          .flatMap((ts: any) => {
            const tenancyId = ts?.tenancySummary?.tenancyId;
            const paymentReference = ts?.tenancySummary?.paymentReference;
            return ts?.tenancySummary?.premisesIds.map((premiseId: any) => ({
              tenancyId,
              premiseId,
              paymentReference
            })) || [];
          });

        const promises = activeTenanciesPremises.map(async (item: any) => {
          const data = await fetchAssetInfo(item.premiseId);
          return {
            tenancyId: item.tenancyId,
            premiseId: item.premiseId,
            paymentReference: item.paymentReference,
            data
          };
        });

        Promise.all(promises).then((results) => {
          const associatedAssetsList: AssocitaedAssetsType[] = [];
          results.forEach((item: any) => {
            const address = findAddress(item);
            const uniqueKey = `${item.premiseId}_${item.tenancyId}_${item.paymentReference}`;
            const associatedAssetsTypeEntry: AssocitaedAssetsType = new AssocitaedAssetsType();
            associatedAssetsTypeEntry.key = uniqueKey;
            associatedAssetsTypeEntry.value = address?.addresses?.postalAddresses?.[0]?.formattedAddress;
            associatedAssetsList.push(associatedAssetsTypeEntry);
          });
          const premiseId = associatedAssetsList[0]?.key.split("_")[0];

          setInAssociatedAssetsList(associatedAssetsList);
          //Former Tenancy Case
          if (associatedAssetsCount < 1) {
            setDefaultAssociatedAsset(associatedAssetsList[0]?.key);
            getAssociatedAsset(premiseId)
            getGasBoilerData(premiseId);
            dispatch(defaultAssetId(premiseId))
            dispatch(userChosenPropertyAddress(associatedAssetsList[0]?.value));
            dispatch(
              updateDashboardForm({
                assetId: premiseId
              })
            );
            dispatch(isActiveTenancy(false));
            setActiveTenancy(false);
            let TenancySummaryEntry = inActiveTenanciesSummaries.find(
              (st) => st.tenancySummary.premisesIds[0] === premiseId
            );
            if (TenancySummaryEntry !== undefined && TenancySummaryEntry !== null) {

              // Dispatch Tenency Id to retrieve cases for former customer with all past tenencies
              dispatch({ type: CASE_TENANCY_ID, payload: TenancySummaryEntry?.tenancySummary?.tenancyId })

              let paymentReference =
                TenancySummaryEntry?.tenancySummary?.paymentReference;
              let tenancyResponseEntry = tenancyResponse.find(x => x.tenancyIdentifier === TenancySummaryEntry?.tenancySummary?.tenancyId)
              if (tenancyResponseEntry !== undefined && tenancyResponseEntry !== null) {
                tenancyGroup =
                  tenancyResponseEntry?.tenancyGroup;
                if (tenancyGroup !== undefined && tenancyGroup !== null) {
                  dispatch(userChosentenancyGroup(tenancyGroup));
                }
              }
              if (paymentReference !== undefined && paymentReference !== null && !hideCustomerKeyDetails) {
                (async () => {
                  let accountBalance: any;
                  try {
                    accountBalance = await fetchAccountData(paymentReference);
                    errorData = removeAPIError(getAccountByIdServiceCharges, errors);
                    dispatch(storeAPIErrors(errorData));
                    getCustomeAccountData(true, paymentReference)
                    accountBalance["balance"].forEach((balance: any) => {
                      if (balance["balance-type"] === BalanceType.Livebalanced) {
                        let liveBalanced = balance["monetary-amount"]["value"];
                        let number =
                          liveBalanced !== null
                            ? Math.abs(liveBalanced.toString().replace(/,/g, ""))
                            : 0.0;
                        if (number === 0) {
                          setShowRent(false)
                        }
                        else {
                          setShowRent(true)
                        }
                      }
                    })

                    dispatch(
                      userChosenAccountData(accountBalance)
                    );
                  }
                  catch (e) {
                    console.log(e);
                    errorData = addAPIError(getAccountByIdServiceCharges, errors);
                    dispatch(storeAPIErrors(errorData));
                    getCustomeAccountData(false, null)
                    dispatch(
                      userChosenAccountData(null)
                    );
                    setIsLoading(false)
                  }
                })();
                dispatch(userChosenAccountNumber(paymentReference));
              }
            }
          }
          associatedAssetsCount = associatedAssetsCount + associatedAssetsList.length;
          setArea(associatedAssetsCount > 1);
        })
      }
      else {
        if (associatedAssetsCount > 1) {
          setArea(true);
        } else {
          setArea(false);
        }
      }
    }
    catch (e) {
      setIsLoading(false)
      console.error(e);
    }
  }
  const findAddress = (item: any) => {
    return item.data?.find(
      (addressItem: any) => addressItem.id === item.premiseId
    );
  };

  const propertySelectOptions = {

    current: {
      options: optionsFromPremises(associatedAssetList),
      order: 1,
    },
    previous: {
      options: optionsFromPremises(inAssociatedAssetList),
      order: 2,
    },
  }
  dispatch(getAssetList(propertySelectOptions));
  const backButtonHandler = () => {
    if (finishJourney) {
      props.history.push("/LandingView")
    }
    else if (props.location.pathname === "/Customer360View") {
      props.history.push("/LandingView")
    }
    else
      history.goBack()
  };
  const callPageHandler = () => {

    if (!isP360Maintainence) {
      dispatch(priorityCode(''));
      dispatch(woFailureCase());
      dispatch(getPreviousPageName("customer"));
      props.history.push("/RepairAsset", { previousPathname: window.location.pathname });
    }
  };
  const callCaseHandler = () => {
    backToCaseAsset(false)
    if (associatedAssetList.length === 1) {
      props.history.push("/CaseAsset");
    }
    else if (associatedAssetList.length > 1) {
      props.history.push("/SelectTenancy");
    }
  }
  const callVantageOnline = () => {
    const vatageURL = getDeepLink(CustomerOrProperty.Customer, customerId)
    window.open(vatageURL, '_blank')
  }
  const dropDownFunction = () => {
    if (dropDown === "none")
      setDropDown("block");
    else
      setDropDown("none");
  }
  const handleChangeAssociate = (e: any) => {
    const [selectedPremise, selectedTenancy, selectedPaymentReference] = e?.split("_") || [];

    setIdentifiedCatalystProperty(false);
    setCatalystBannerMessageA("");
    setCatalystBannerMessageB("");
    dispatch(isCatalystProperty(false))
    setDefaultAssociatedAsset(e);

    callAlertApi(selectedPremise);
    getAssociatedAsset(selectedPremise);

    const result = associatedAssetList.find(x => x.key.split("_")[0] === selectedPremise && x.key.split("_")[1] === selectedTenancy && x.key.split("_")[2] === selectedPaymentReference);
    if (result) {
      dispatch(userChosenPropertyAddress(result.value));
      dispatch(isActiveTenancy(true));
      setActiveTenancy(true);
      dispatch(
        updateDashboardForm({
          assetId: selectedPremise
        })
      );
    }
    else {
      dispatch(isActiveTenancy(false));
      setActiveTenancy(false);
    }
    let TenancySummaryEntry = customerData?.tenanciesSummaries.find(
      (st) => st.tenancySummary.premisesIds[0] === selectedPremise
    );
    dispatch({ type: CASE_TENANCY_ID, payload: TenancySummaryEntry?.tenancySummary?.tenancyId })
    if (TenancySummaryEntry !== undefined && TenancySummaryEntry !== null) {

      let tenancyResponseEntry = tenanciesData.find(x => x.tenancyIdentifier === TenancySummaryEntry?.tenancySummary?.tenancyId)
      if (tenancyResponseEntry !== undefined && tenancyResponseEntry !== null) {
        tenancyGroup =
          tenancyResponseEntry?.tenancyGroup;
        if (tenancyGroup !== undefined && tenancyGroup !== null) {
          dispatch(userChosentenancyGroup(tenancyGroup));
        }
      }
      let paymentReference =
        TenancySummaryEntry?.tenancySummary?.paymentReference;
      const tenancyType = TenancySummaryEntry?.tenancySummary?.tenancyType;
      getGasBoilerData(selectedPremise);
      setEICRServiceAlert("")
      setGASServiceAlert("")
      if (paymentReference !== undefined && paymentReference !== null && !hideCustomerKeyDetails) {
        (async () => {
          try {
            const accountBalance = await fetchAccountData(paymentReference);
            getCustomeAccountData(true, paymentReference)
            if (!result) {
              accountBalance["balance"].forEach((balance: any) => {
                if (balance["balance-type"] === BalanceType.Livebalanced) {
                  let liveBalanced = balance["monetary-amount"]["value"];
                  let number =
                    liveBalanced !== null
                      ? Math.abs(liveBalanced.toString().replace(/,/g, ""))
                      : 0.0;
                  if (number === 0) {
                    setShowRent(false)
                  }
                  else {
                    setShowRent(true)
                  }
                }
              })
            }
            dispatch(
              userChosenAccountData(accountBalance)
            );
          }
          catch (e) {
            console.log(e);
            getCustomeAccountData(false, null)
            dispatch(
              userChosenAccountData(null)
            );
            setIsLoading(false)
          }
        })();
        dispatch(userChosenAccountNumber(paymentReference));
      }
    }
  };
  const getCustomeAccountData = (rentCard: boolean, paymentReference: string | null) => {
    (async () => {
      try {
        let accountCustomerResponse = await api.getAccountByCustomers(customerId);
        dispatch(storeAPIErrors(removeAPIError(getAccountsByCustomerId, errors)));
        setcustomerAccountDataValue(accountCustomerResponse);
        dispatch(userChosenCustomerAccountData(accountCustomerResponse));
        let accountCount = 0
        if (paymentReference !== null) {
          accountCustomerResponse?.forEach((accountBalance: any) => {
            if (accountBalance.identifiers['pay-ref'].replace(/[^0-9]/g, '') === paymentReference) {
              if (accountBalance['account-type'] === AccountTypeList.REN ||
                accountBalance['account-type'] === AccountTypeList.DEP ||
                accountBalance['account-type'] === AccountTypeList.FD5 ||
                accountBalance['account-type'] === AccountTypeList.GRD ||
                accountBalance['account-type'] === AccountTypeList.MJW ||
                accountBalance['account-type'] === AccountTypeList.HOM

              ) {
                accountCount = accountCount + 1;
              }
            }
          })
          if (rentCard === true && accountCount < 2) {

            setShowRent(true)
          }

        }
        else {
          if (accountCustomerResponse?.length !== 0) {
            setShowAccount(true)
          }
          else {
            setShowAccount(false)
          }
        }

        setIsLoading(false)
      }
      catch (e) {
        setShowAccount(true)
        setShowRent(true)
        setIsCustomerAccountAPIFailure(true);
        dispatch(storeAPIErrors(addAPIError(getAccountsByCustomerId, errors)));
        setIsLoading(false)
        console.error(e);
      }
    })()
  }

  const callAlertApi = (assetId: string) => {
    (async () => {
      try {
        const alertApiResponse = await api.getAlert(assetId);
        let finalAlertData: any[] = [];
        if (alertApiResponse) {
          alertApiResponse.map((alertData: any) => {
            if (alertData?.type === AlertValue.Rapid) {
              finalAlertData.push(alertData);
              setPropertyBannerCheck(true);
              dispatch(userChosenAlertValue(finalAlertData));
            } else {
              setPropertyBannerCheck(false);
            }
          })
        }
        else {
          setPropertyBannerCheck(false);
        }

      } catch (e) {
        console.error(e);
      }
    })()
  };
  const isKebabMenuVisible =
    (activeTenancy && isRepair) ||
    (isServiceRequestCard && activeTenancy && isCaseCheck === 'true') ||
    showVantage;
  if (isLoading) {
    return (
      <div className="div-loader">
        <div className="SpinnerWrapper">
          <LoadingSpinner />
        </div>
      </div>
    );
  }
  return (
    <div className="border-t border-grey bg-no-repeat bg-right-60% bg-50% md:bg-35% lg:bg-20% bg-fixed">
      <div className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0 global-txt flex space-between">
        <div id="backmodal-div1" className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0" >
          <p id="backmodal-p" className="text-teal text-xl mt-4 mb-4 md:mb-12 sm-pl-1">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a data-testid="custBackBtn" className="back-btn" onClick={backButtonHandler} onKeyPress={backButtonHandler}>
              <i className="fas fa-angle-left mr-2"></i>
              {t("back")}
            </a>
          </p>
        </div>
        <div className="menu-nav ms-auto bd-highlight ">
          {isKebabMenuVisible && (
            <div className="dropdown-container-h btn-group">
              <div data-testid="dotsmenu"
                className="kebabBtn mr-1 btn btn-sm show three-dots-ast mt-3"
                data-bs-toggle="dropdown"
                onClick={dropDownFunction}
                onKeyPress={dropDownFunction}>
              </div>

              <div className="dropdown-ast px-2 dropdown-menu show mt-45" style={{ display: dropDown }}>
                {isAssetEligibleForRepair && (activeTenancy && isRepair ? (
                  /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                  <a data-testid="callpage" onClick={callPageHandler} onKeyPress={callPageHandler} className="text-black no-underline">
                    <div className={"cursor-pointer text-base text-black dropdown-item " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>{t("Create_repair")}</div></a>
                )
                  : null
                )}

                {createCaseStandard && activeTenancy && isCaseCheck === 'true' ? (
                  /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                  <a data-testid="casepage" onClick={callCaseHandler} onKeyPress={callCaseHandler} className="text-black text-base no-underline global-txt">
                    <div className="py-2 cursor-pointer text-black text-base no-underline dropdown-item">{t("CP104")}</div></a>
                ) : null}


                {showVantage ? (
                  /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
                  <a data-testid="vantagepage" onKeyDown={callVantageOnline} onClick={callVantageOnline} className="text-black text-base no-underline global-txt">
                    <div className="py-2 cursor-pointer text-black text-base no-underline dropdown-item">
                      {t("open_vantage")}
                      <span className="float-right pt-1"><img
                        src={openNewWindow}
                        alt=""
                        className="h-4 w-4 my-0 text-lg text-teal"
                      ></img></span>

                    </div></a>
                ) : null}
              </div>
            </div>
          )}
        </div>

      </div>

      <div className="container px-4s">
        <div className="w-full lg:px-0 mb-4">
          <div className="global-txt" >

            <div className="flex flex-row d-flex bd-highlight">
              <div className="bd-highlight">
                <h1 className="mb-4 mt-2 mpx-4">{customerData?.person.name.title} {customerData?.person.name.givenName} {customerData?.person.name.surname ?? "-"}</h1>
                <p className="mt-2 global-txt">{t("CP008a")}</p>
              </div>
            </div>
          </div>
          {Area ? (
            <div>
              <div className="global-txt mb-1 mt-2">{t("Select_your_tenancy")}</div>
              <label className="block">
                <PropertySelect
                  className="block w-full mt-2 rounded border-grey"
                  data-bdd="property-select"
                  id="property-select"
                  data-testid="propertyselect"
                  disabled={associatedAssetList.length + inAssociatedAssetList.length === 1}
                  defaultValue={defaultAssociatedAsset}
                  onChange={handleChangeAssociate}
                  options={propertySelectOptions}
                  variant="outlined"
                  fullWidth={true}
                />
              </label>
            </div>
          ) : associatedAssetList.length > 0 ? (
            associatedAssetList.map((e, key) => {
              return (
                <div>
                  <input
                    className="block w-full mt-2 rounded border-grey mob-view"
                    type="text"
                    aria-label="Search Address Data"
                    disabled={true}
                    key={key}
                    value={
                      e.value.length > 42
                        ? e.value.slice(0, 42) + ".."
                        : e.value
                    }
                  ></input>
                  <input
                    className="block w-full mt-2 rounded border-grey desk-view"
                    type="text"
                    aria-label="Search Address Data"
                    disabled={true}
                    key={key}
                    value={e.value}
                  ></input>
                </div>
              );
            })
          ) : (
            inAssociatedAssetList.map((e, key) => {
              return (
                <div>
                  {" "}
                  <input
                    className="block w-full mt-2 rounded border-grey mob-view"
                    type="text"
                    aria-label="Search Address"
                    disabled={true}
                    key={key}
                    value={e.value.length > 42
                      ? e.value.slice(0, 42) + ".."
                      : e.value}
                  ></input>
                  <input
                    className="block w-full mt-2 rounded border-grey desk-view"
                    type="text"
                    aria-label="Search Address"
                    disabled={true}
                    key={key}
                    value={e.value}
                  ></input>
                </div>
              );
            })
          )}
          {!activeTenancy ? (
            <div className="alert p-0 mb-8">
              <div className="w-full px-2 py-2 bg-purple-20 flex items-center mt-2">
                <div className="px-4 pr-8">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="text-purple-100 w-6 h-6">
                    <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path></svg>
                </div>
                <div className="flex items-center">
                  <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                    {t("CP027")}</p>
                </div>
              </div>
            </div>
          ) : null}

          {identifiedCatalystProperty ? (
            <div className="warning-pre-line mt-2 p-0">
              <div className="w-full px-2 py-2 bg-purple-20 flex items-center">
                <div className="px-4 pr-8">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    fill="currentColor"
                    className="text-purple-100 w-6 h-6"
                  >
                    <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path>
                  </svg>
                </div>
                <div className="flex items-center">
                  <div className="w-full text-left my-2 font-AvantGardeGothic-Md">
                    <div>{catalystBannerMessageA}</div>
                    <br />
                    <div>{catalystBannerMessageB}</div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {EICRserviceAlert && EICRCardToggleValue === "true" && (
            <RedAlert alertType={""} Alert={EICRserviceAlert} {...props} />
          )}
          {GASserviceAlert && GASCardToggleValue === "true" && (
            <RedAlert alertType={""} Alert={GASserviceAlert} {...props} />
          )}

          {isCautionBanner && preferenceCheck ? (
            <div className="mt-2">
              <CautionAlert {...props} />
            </div>
          ) : null}
          {additionalAlert ? (
            <div className="mt-2">
              <AdditionalNeedAlert {...props} />
            </div>
          ) : null}
          {isPropertyBanner && propertyBannerCheck ? (
            <div className="mt-2">
              <PropertyAlert {...props} />
            </div>
          ) : null}
        </div>

        <div className="row g-4">
          {isKeyContact && (
            <div className="col-md-6">
              {tenancyStatus && <KeyContact {...props} selectedProperty={defaultAssociatedAsset} />}
            </div>
          )}
          {isCustomerCard ? (
            <div className="col-md-6">
              <CustomerCard errorFlag={errorCustomerFlag} {...props} />
            </div>
          ) : null
          }
          {isWorkCard && showworksOrderSurveys ? (
            <div className="col-md-6">
              <WorkCard {...props} />
            </div>
          ) : null}
          {isServiceRequestCard && isCaseCard === false && isCaseCheck === 'true' ? (
            <div className="col-md-6" data-testid="service-request-card">
              <CaseCard errorFlag={errorCustomerFlag} {...props} />
            </div>
          ) : null}
          {isAssetCard ? (
            <div className="col-md-6">
              <AssetCard errorFlag={errorCustomerFlag} {...props} />
            </div>
          ) : null}

          {isRentAccountCard && isAccountCard && showAccount && (isCustomerAccountAPIFailure || !showRent) ? (

            <div className="col-md-6" data-testid="rent-account-card">
              {(isCustomerAccountAPIFailure || customerAccountDataValue) && <AccountCard {...props} />}
            </div>

          ) : null}

          {isRentCard && showRent && (
            <div className="col-md-6">
              <RentCard {...props} />
            </div>
          )}

          {isUCCCard && activeTenancy && customerAccountDataValue ? (
            <>
              {isTenancyDetailsCard ? (
                <div className="col-md-6" data-testid="tenancy-details-card">
                  <UCCTenancyDetails {...props} />
                </div>
              ) : null}
              {isRentDetailsCard ? (
                <div
                  className="col-md-6"
                  data-testid="tenancy-rent-details-card"
                >
                  <UCCRentDetails errorFlag={errorFlag} {...props} />
                </div>
              ) : null}
            </>
          ) : null}

          {(backToTop && width <= 820) && <BackToTopComponent />}
        </div>
      </div>
    </div>
  );
};

export default Customer360View;